import { render, staticRenderFns } from "./ALlDemand.vue?vue&type=template&id=6baf134e&scoped=true&"
import script from "./ALlDemand.vue?vue&type=script&lang=js&"
export * from "./ALlDemand.vue?vue&type=script&lang=js&"
import style0 from "./ALlDemand.vue?vue&type=style&index=0&id=6baf134e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baf134e",
  null
  
)

export default component.exports